const importFileTypes = '.xlsx,.xls,.xla,.xlt,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv';

export default importFileTypes;



// WEBPACK FOOTER //
// ./src/config/importFileTypes.js